import {
  Lit3formBlock,
  html,
  classMap,
  unsafeHTML,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

// Important Note: Dipper and Mabel are twins. They are quite similar but have
// subtle differences. That said, keep in mind that a change made to one
// ** might ** also be needed in the other.

export class Dipper extends Lit3formBlock {
  static get characterName() {
    return 'dipper';
  }

  static get characterProperties() {
    return {
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid dipper-layout">
          ${this.headerHTML} ${this.imagesHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get imagesHTML() {
    return this.imagesArr.length
      ? html`
          <div
            class="${classMap({
              'two-per-row': this.imagesPerRow === 'two',
              'three-per-row': this.imagesPerRow === 'three',
              images: true,
            })}"
          >
            ${this.imagesArr.map(
              i => html`
                <div class="image-wrapper">
                  ${this.imageInternalHtml(i[1])}
                </div>
              `
            )}
          </div>
        `
      : html``;
  }

  imageInternalHtml(image) {
    const imageHeader = html`
      <div
        class="${classMap({
          'image-header': true,
          'top-spacer': this.useColumnLayout,
        })}"
      >
        <h3 class="image-title">
          ${unsafeHTML(this.withLineBreaks(image.title))}
        </h3>
        <cta-text
          class="mobile-only"
          cta-data=${this.imageCtaData(image)}
          .ctaAnalyticsData=${analyticsCtaDataObject(image, this.headerText)}
        ></cta-text>
      </div>
    `;
    const img = html`
      <a
        class="image"
        href=${this.imageHref(image)}
        rel="noopener"
        @click="${event => this.handleMediaClick(image, event)}"
      >
        <img src=${this.imageUrl(image)} />
      </a>
    `;

    const paragraph = html`
      <p class="image-description font-size-small">
        ${unsafeHTML(this.withLineBreaks(image.description))}
      </p>
    `;

    const ctaText = html`
      <cta-text
        class="desktop-only"
        cta-data=${this.imageCtaData(image)}
        .ctaAnalyticsData=${analyticsCtaDataObject(image, this.headerText)}
      ></cta-text>
    `;

    return this.useColumnLayout
      ? html`
          ${img}${imageHeader}${paragraph}${ctaText}
        `
      : html`
          ${imageHeader}${img}${paragraph}${ctaText}
        `;
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  imageUrl(image) {
    return this.imagebossUrl(image.src, 500);
  }

  imageCtaData(image) {
    let cta = {};
    if (image) {
      cta.text = image.text;
      cta.url = image.url;
    }
    return JSON.stringify(cta);
  }

  get useColumnLayout() {
    return this.content.column_layout === '1';
  }

  get imagesPerRow() {
    return this.content.images_per_row || 'three';
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <div class="${classMap(this.layoutClasses)}">
            <h2 class="header">${unsafeHTML(this.headerText)}</h2>
            ${this.descriptionHTML} ${this.ctaHTML}
          </div>
        `
      : ``;
  }

  get ctaData() {
    const ctaData = this.content.cta || null;
    if (!ctaData) return null;

    ctaData.fullWidth = true;
    return JSON.stringify(this.content.cta);
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description">
            ${unsafeHTML(this.descriptionText)}
          </p>
        `
      : ``;
  }

  get ctaHTML() {
    return this.ctaData
      ? html`
          <div class="cta-wrapper">
            <cta-button
              cta-data=${this.ctaData}
              cta-type="primary"
              .ctaAnalyticsData=${analyticsCtaDataObject(
                this.ctaInfo,
                this.headerText
              )}
            ></cta-button>
          </div>
        `
      : html``;
  }

  get layoutClasses() {
    const classes = {};
    this.useColumnLayout
      ? (classes['column-layout'] = true)
      : (classes['default-layout'] = true);
    return classes;
  }
}
Dipper.defineElement();
